import api from "api";
import { useEffect, useState } from "react";
import { formErrorStrfromObj } from "utils/shared";
import { useDispatch } from "react-redux";
import { setDialog, setLoading } from "slices/appSlice";

export const useFetchRuleProcesses = () => {
  const dispatch = useDispatch();
  const [processList, setprocessList] = useState([]);

  const fetchRuleProcesses = async () => {
    dispatch(setLoading(true));
    try {
      const response = await api.ruleConfigProcess.getRuleConfigProcesses();
      if (response.status === 200) setprocessList(response.data);
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
  useEffect(() => {
    fetchRuleProcesses();
  }, []);
  return [processList, fetchRuleProcesses];
};

export const useFetchRuleProcessesRule = () => {
  const dispatch = useDispatch();
  const [rulesList, setrulesList] = useState([]);

  const fetchRuleProcessesRule = async (processId) => {
    dispatch(setLoading(true));
    try {
      const response =
        await api.ruleConfigProcess.getRuleConfigProcessRule(processId);
      if (response.status === 200) setrulesList(response.data);
      return response.data;
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return [rulesList, fetchRuleProcessesRule, setrulesList];
};

export const useFetchAllRuleSet = () => {
  const dispatch = useDispatch();
  const [allRuleSets, setAllRuleSets] = useState([]);

  const fetchAllRuleSets = async () => {
    dispatch(setLoading(true));
    try {
      const response = await api.ruleConfigProcess.getAllRuleSets();
      if (response.status === 200) setAllRuleSets(response.data);
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
  useEffect(() => {
    fetchAllRuleSets();
  }, []);
  return [allRuleSets, fetchAllRuleSets];
};

export const useFetchAllRules = (loadPolicyTags = false) => {
  const dispatch = useDispatch();
  const [allRules, setAllRules] = useState([]);

  const fetchAllRules = async () => {
    dispatch(setLoading(true));
    try {
      const response = await api.ruleConfigProcess.getAllRules(loadPolicyTags);
      if (response.status === 200) setAllRules(response.data);
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
  useEffect(() => {
    fetchAllRules();
  }, []);
  return [allRules];
};

export const useFetchRuleFields = () => {
  const dispatch = useDispatch();
  const [fieldList, setfieldList] = useState([]);

  const fetchRuleFields = async () => {
    dispatch(setLoading(true));
    try {
      const response = await api.ruleConfigProcess.getRuleFields();
      if (response.status === 200) setfieldList(response.data);
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchRuleFields();
  }, []);

  return [fieldList, fetchRuleFields, setfieldList];
};

export const useFetchRuleSet = (ruleSetId) => {
  const dispatch = useDispatch();
  const [ruleSet, setruleSet] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRuleSet = async (ruleSetId) => {
    dispatch(setLoading(true));
    setIsLoading(true);
    try {
      const response = await api.ruleConfigProcess.getRuleSetById(ruleSetId);
      if (response.status === 200) setruleSet(response.data);
    } catch (e) {
      dispatch(setDialog({ message: formErrorStrfromObj(e), title: "Error" }));
    } finally {
      setIsLoading(false);
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    if (ruleSetId) fetchRuleSet(ruleSetId);
  }, []);

  return [ruleSet, fetchRuleSet, isLoading, setruleSet];
};
